import React from "react";
import { Control, actions } from "react-redux-form";
import { Row, Col } from "reactstrap";
import { compose, withHandlers, withPropsOnChange } from "recompose";
import shortid from "shortid";
import { Trans } from "react-i18next";
import { formatDate } from "services/util";
import {
  FormGroup,
  required,
  Page,
  onMount,
  withReload,
  withLocalForm,
} from "components/common";
import {
  withXeroErrors,
  LineItemsView,
  withContactSearch,
  withDocumentRenderer,
} from "components";
import {
  BillCreditNoteDocument,
  InvoiceCreditNoteDocument,
} from "components/documents";
import BackButton from "components/refactoring/BackButton";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import { Link } from "react-router-dom";

export const ViewRepeating = ({
  item,
  LocalForm,
  onSubmit,
  xero,
  dispatch,
  XeroErrors,
  t,
  payable,
  DocumentRenderer,
  EmailDocument,
  DownloadDocument,
}) => {

  const getRepeatMethod = (unit, period) => {
    if (period === 1) {
      return unit === "MONTHLY" ? "Month" : (unit === "WEEKLY" ? "Week" : unit);
    } else {
      return unit === "MONTHLY" ? `${period} Months` : (unit === "WEEKLY" ? `${period} Weeks` : unit);
    }
  };

  console.log(getRepeatMethod("MONTHLY", 8), "AA");

  const SpanColor = ({ children }) => {
    const colorInheritStyle = {
      color: '#525f7f',
      fontSize: "1.2em",
    };

    return <span style={colorInheritStyle}>{children}</span>;
  };

  const cStyle = {
    status: {
      style: { fontWeight: 'bold', fontSize: '1.3em', color: '#72B566' },
    },
    common: {
      className: "pt-3 pb-3",
      xs: false,
      md: 3,
    },
  };

  const typeDue = (dueDateType) => {
    const mappings = {
      DAYSAFTERBILLDATE: t`day(s) after bill date`,
      DAYSAFTERBILLMONTH: t`day(s) after bill month`,
      OFCURRENTMONTH: t`of the current month`,
      OFFOLLOWINGMONTH: t`of the following month`,
      DAYSAFTERINVOICEDATE: t`day(s) after invoice date`,
      DAYSAFTERINVOICEMONTH: t`day(s) after invoice month`,
    };

    return mappings[dueDateType] || dueDateType;
  };

  const getStatus = (status) => {
    const mappings = {
      AUTHORISED: t`On going`,
      DRAFT: t`In Draft`,
    };

    return mappings[status] || status;
  };

  const dateChange = (day) => {
    const suffix =
      day >= 11 && day <= 13
        ? 'th'
        : day % 10 === 1
          ? 'st'
          : day % 10 === 2
            ? 'nd'
            : day % 10 === 3
              ? 'rd'
              : 'th';

    return `${day}${suffix}`;
  };

  const viewLink = () => {
    const { RepeatingInvoiceID } = item;

    window.location.href = `/accounts_receivable/repeating/edit/${RepeatingInvoiceID}`;
  };

  return (

    <div>
      <Page
        title={t(`View Repeating {{ ID }}`, {
          ID: item.Reference,
        })}
        translate={false}
      >
        <BackButton />
        <DocumentRenderer
          component={payable ? BillCreditNoteDocument : InvoiceCreditNoteDocument}
        />
        <XeroErrors />
        <div className="d-flex">
          {item.SentToContact && (
            <div className="text-success small">
              <span className="fa fa-check mr-1" /> <Trans>Sent to contact</Trans>
            </div>
          )}
          <div className="mx-auto" />
          {item.RepeatingInvoiceID && <DownloadDocument className="mr-2" />}
          {(item.RepeatingInvoiceID && !payable) && (
            <EmailDocument type="CREDIT_NOTE" item={item} />
          )}
          {!!item.RepeatingInvoiceID && <div className="">
            <button
              type="button"
              className="btn-sm btn btn-primary"
              onClick={viewLink}>
              Duplicate Invoice
            </button>
          </div>}
        </div>
        <LocalForm
          onSubmit={onSubmit}
          validators={{
            Contact: { required },
            Date: { required },
            "LineItems[].Description": { required },
          }}
        >
          <Row>
            <Col {...cStyle.common}>
              <FormGroup label="To" model=".Name" >
                <Link to={`/contacts/view/${item.Contact.ContactID}`} {...cStyle.status}>
                  {item.Contact.Name}
                </Link>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Status">
                <SpanColor>{getStatus(item.Status)}</SpanColor>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Repeats" >
                <SpanColor>Every {getRepeatMethod(item.Schedule.Unit, item.Schedule.Period)}</SpanColor>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Reference" model=".Reference">
                <SpanColor>{item.Reference || '---'}</SpanColor>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Next Invoice Date" >
                <SpanColor>{formatDate(item.Schedule.NextScheduledDateString)}</SpanColor>
              </FormGroup>
            </Col>
            <Col {...cStyle.common}>
              <FormGroup label="Due Date" >
                <SpanColor>{dateChange(item.Schedule.DueDate)} {typeDue(item.Schedule.DueDateType)}</SpanColor>
              </FormGroup>
            </Col>
          </Row>
          <hr />
          <LineItemsView
            item={item}
            dispatch={dispatch}
            xero={xero}
            hideAddLines={true}
            hideAccountAndTax={true}
            removeLine={false}
          />
        </LocalForm>
      </Page>
    </div>
  )
};

const enhance = compose(
  withOrganisationContextConsumer,
  withPropsOnChange(["payable"], ({ payable }) => {
    const type = payable ? "ACCPAY" : "ACCREC";
    return {
      type,
      payable: payable,
    };
  }),
  withReload(),
  onMount(({ match, xero, location, type, fetchOrganisation }) => () => {
    const { id } = match.params;
    let item = null;
    item = xero
      .get(`repeatinginvoices/${match.params.id}`)
      .get("data")
      .then((x) => ({
        ...x,
        LineItems: x.LineItems.map((i) => ({
          ...i,
          _id: shortid(),
        })),
      }));
    return Promise.props({
      item,
      organisation: fetchOrganisation(),
    });
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
  withContactSearch(),
  withXeroErrors(),
  withHandlers({
    handleAttachmentsChanged:
      ({ xero, match, dispatch }) =>
        () => {
          xero
            .get(`repeatinginvoices/${match.params.id}/attachments`)
            .get("data")
            .tap((d) => dispatch(actions.change("local.Attachments", d)));
        },
  }),
  withDocumentRenderer({
    onDownload:
      ({ item }) =>
        (getDocument) =>
          getDocument(
            {
              item,
            },
            `repeating_${item.RepeatingInvoiceID}.pdf`
          ),
  })
);

export default enhance(ViewRepeating);
